import {
  Button,
  Dialog,
  Backdrop,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
  DialogContentText,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import loaderLogoSrc from 'assets/images/idecon-loader-logo.png';
import { GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteProjectStepDialogProps = {
  open: boolean;
  projectStepId: number | null;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
};

const DeleteProjectStepDialog = ({
  open,
  projectStepId,
  handleClose,
  refresh,
  setRowSelectionModel,
}: DeleteProjectStepDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    if (!projectStepId) return;

    try {
      setLoading(true);

      const response = await apiService.deleteProjectStep(projectStepId);

      if (response.isSuccess) {
        enqueueSnackbar(
          <FormattedMessage
            id="projectStepManaging.deleteProjectStepCompleted"
            defaultMessage="Seçili proje adımını silme işlemi başarıyla tamamlandı."
          />,
          { variant: 'success' }
        );
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <FormattedMessage id="projectStepManaging.deleteProjectStep" defaultMessage="Proje Adımı Sil" />
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <DialogContentText>
          <FormattedMessage
            id="projectStepManaging.deleteProjectStepRepeat"
            defaultMessage="Bu işlem onaylandıktan sonra proje adımı veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>
          <FormattedMessage id="forgotPassword.cancel" defaultMessage="Vazgeç" />
        </Button>
        <Button variant="contained" type="button" onClick={handleDelete}>
          <FormattedMessage id="forgotPassword.continue" defaultMessage="Devam" />
        </Button>
      </DialogActions>
      <Backdrop
        sx={{ display: 'flex', flexDirection: 'column', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}>
        <img src={loaderLogoSrc} alt="loader-logo" />
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default DeleteProjectStepDialog;
